/* CPK colour guide — tile selection + Sweet/Sour filter.
 *
 * The section server-renders the featured card for the initial flavour; this
 * script only swaps it when another tile is picked. Every value comes from
 * the tile's data-* attributes (merchant block settings), and all copy that
 * wraps them (CTA label, image alt) rides data-* on the root.
 */
(function () {
  function init(root) {
    if (root.dataset.kkBound) return;
    root.dataset.kkBound = '1';

    var el = window.KKEl;
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-kkcg-tile]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-kkcg-filter]'));
    var img = root.querySelector('[data-kkcg-img]');
    var name = root.querySelector('[data-kkcg-name]');
    var vibes = root.querySelector('[data-kkcg-vibes]');
    var palette = root.querySelector('[data-kkcg-palette]');
    var cta = root.querySelector('[data-kkcg-cta]');
    var ctaLabel = root.dataset.ctaLabel || 'Shop [name] →';
    var altPattern = root.dataset.altPattern || '[name]';
    // Palette slots per flavour (colour_1 … colour_6 block settings).
    var MAX_COLOURS = 6;

    function swatch(n, c, light, share) {
      var s = el('span', 'kkcg__swatch' + (light ? ' is-light' : ''));
      s.appendChild(el('span', 'kkcg__swatch-label', n));
      s.style.background = c;
      s.style.flexGrow = share || 50;
      return s;
    }

    function select(tile) {
      var d = tile.dataset;
      tiles.forEach(function (t) { t.setAttribute('aria-pressed', t === tile ? 'true' : 'false'); });

      if (img) {
        if (d.img) {
          img.src = d.img;
          img.alt = altPattern.split('[name]').join(d.name || '');
          img.hidden = false;
        } else {
          img.hidden = true;
        }
      }
      if (name) name.textContent = d.name || '';
      if (vibes) {
        vibes.textContent = '';
        (d.vibes || '').split(' · ').forEach(function (v) {
          if (v) vibes.appendChild(el('span', 'kkcg__vibe', v));
        });
      }
      if (palette) {
        palette.textContent = '';
        for (var n = 1; n <= MAX_COLOURS; n++) {
          var c = 'c' + n;
          if (d[c + 'Name']) palette.appendChild(swatch(d[c + 'Name'], d[c], (c + 'Light') in d, d[c + 'Share']));
        }
        palette.hidden = !palette.firstChild;
      }
      if (cta) {
        var label = ctaLabel.split('[name]').join(d.name || '');
        if (window.KKIcons && window.KKIcons.labelInto) window.KKIcons.labelInto(cta, label);
        else cta.textContent = label;
        if (d.url) { cta.href = d.url; cta.hidden = false; }
        else { cta.hidden = true; }
      }
    }

    root.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-kkcg-tile]');
      if (tile && root.contains(tile)) { select(tile); return; }

      var chip = e.target.closest('[data-kkcg-filter]');
      if (!chip || !root.contains(chip)) return;
      var f = chip.dataset.kkcgFilter;
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      tiles.forEach(function (t) { t.hidden = f !== 'all' && t.dataset.tag !== f; });

      var current = tiles.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; })[0];
      if (current && current.hidden) {
        var first = tiles.filter(function (t) { return !t.hidden; })[0];
        if (first) select(first);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-kkcg]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
